const predefinedLocations = [
  {
    name: "Mint Progressive Indian",
    text: "1103 1st Ave, Seattle, WA 98101, United States",
    lat: 47.6053365,
    lng: -122.337284,
    time: "Mon - Sun . 11:00 AM - 09:30 PM",
    number: "+1 206-533-3399"
  },
  {
    name: "Total Wine - Bellevue",
    text: "Wilburton Crossing, 609 120th Ave NE Unit B, Bellevue, WA 98005, United States",
    lat: 47.6159989,
    lng: -122.1852842,
    time: "Mon - Sun . 09:00 AM - 10:00 PM",
    number: "+1 425-454-1317"
  }
];

export default predefinedLocations;
